import React, { useState } from "react";
import { Button, Modal } from "react-bootstrap";
import { Scrollbars } from "react-custom-scrollbars";

export const VendorLearnMore = ({
  heading,
  modalimage,
  paragraphText
}
  ) => {
  const [show, setShow] = useState(false);
  const onOpenModal = () => {
    setShow(true);
  };

  const onCloseModal = () => {
    setShow(false);
  };

  return (
    <React.Fragment>
      <div>
        <span
          className="f10-500 cursor"
          style={{ color: "#2196F3" }}
          onClick={() => onOpenModal()}
        >
          Learn More
        </span>
        <Modal
          show={show}
          onHide={() => onCloseModal()}
          backdrop="static"
          keyboard={true}
          aria-labelledby="contained-modal-title-vcenter"
          centered
        >
          <Modal.Header className="border-bottom-0" closeButton>
            {/* <Modal.Title>Modal heading</Modal.Title> */}
          </Modal.Header>
          <div className="row p-4">
            <div className="col-12">
              <h5 className="f16-500" style={{textAlign:'center'}}>{heading}</h5>
            </div>
            <div className="col-12 mt-3">
              { modalimage && (
                <>
                   <img src={modalimage} alt="image" style={{width:"100%"}}/>
                </>
              )}
              <Scrollbars style={{ height: 400 }}>
                <p className="f14-500" style={{textAlign:'center'}}>{paragraphText}</p>
              </Scrollbars>
            </div>

            <div className="col-12 text-center mt-5">
              <Button
                className="btn f18_500_HelveticaNeue"
                style={{
                  backgroundColor: "#EE3A23",
                  width: "40%",
                  border: "none",
                }}
                type="button"
                onClick={() => onCloseModal()}
              >
                Okay
              </Button>
            </div>
          </div>
        </Modal>
      </div>
    </React.Fragment>
  );
};

export default VendorLearnMore;
